import dayjs from "dayjs";

export enum CalendarItemState {
	Default = "default",
	Today = "today",
	OutOfRange = "outofrange",
	Selected = "selected",
}

export function calculateState(date: Date, selectedDate?: Date): CalendarItemState {
	if (selectedDate && date.toDateString() === selectedDate.toDateString()) {
		return CalendarItemState.Selected;
	}
	if (date.toDateString() === new Date().toDateString()) {
		return CalendarItemState.Today;
	}
	return CalendarItemState.Default;
}

/**
 * Gets the current month/year as a Date object
 */
export function getCurrentMonthYear(): Date {
	return new Date(new Date().getFullYear(), new Date().getMonth(), 1);
}

/**
 * Gets the month/year from a given date as a Date object (first day of that month)
 */
export function getMonthYearFromDate(date: Date): Date {
	return new Date(date.getFullYear(), date.getMonth(), 1);
}

/**
 * Subtracts months from a given date and returns start of that month/year
 */
export function getPreviousMonthYear(date: Date, months: number): Date {
	return dayjs(date).subtract(months, "month").startOf("month").toDate();
}

/**
 * Adds months to a given date and returns start of that month/year
 */
export function getNextMonthYear(date: Date, months: number): Date {
	return dayjs(date).add(months, "month").startOf("month").toDate();
}

/**
 * Formats a date as "MMMM YYYY" (e.g., "January 2024")
 */
export function formatMonthYear(date: Date): string {
	return dayjs(date).format("MMMM YYYY");
}

/**
 * Gets the number of days in the month for a given date
 */
export function getDaysInMonth(date: Date): number {
	return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}

/**
 * Sets a specific day of the month for a given date and returns as Date object
 */
export function setDayOfMonth(date: Date, day: number): Date {
	return new Date(date.getFullYear(), date.getMonth(), day);
}
